// Data
import MetaValues from './data/MetaValues';
import LoginImages from './data/LoginImages';
import LogoPath from './data/LogoPath';
import LoginLogoPath from './data/LoginLogoPath';
import helpUrl from './data/helpUrl';
import AdditionalNavigation from './data/AdditionalNavigation';
import oktaClient from './data/oktaClient';
import FeatureFlags from './data/FeatureFlags';

// Components
import ConsentBanner from './components/ConsentBanner';
import FooterContent from './components/FooterContent';
import LegalMentions from './components/LegalMentions';
import MarketingPermissions from './components/MarketingPermissions';
import MarketingHelp from './components/MarketingHelp';
import SsoButton from './components/SsoButton';

export default {
  // Data
  MetaValues,
  LoginImages,
  LogoPath,
  LoginLogoPath,
  helpUrl,
  AdditionalNavigation,
  oktaClient,
  FeatureFlags,

  // Components
  ConsentBanner,
  FooterContent,
  LegalMentions,
  MarketingPermissions,
  MarketingHelp,
  SsoButton,
};
